// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3jv5n","content":"LoadingAlert_content__3XQCi"};